import React, { useEffect, useRef } from "react";
import AuthSectionContainer from "./AuthSectionContainer";
import { FormControl, TextField } from "@mui/material";
import useManageInput from "../hooks/useManageInput";
import { ButtonLanding } from "../../../components/Buttons";
import { Link } from "react-router-dom";
import "./css/ForgotPassword.css";
import useForgetPassword from "../hooks/useForgetPassword";
import ResponseStatus from "./ResponseStatus";

function ForgotPassword() {
  const {
    value: email,
    valueIsValid: emailIsValid,
    error: emailError,
    setValue: setEmail,
    setError: setEmailError,
    showError: showEmailError,
  } = useManageInput("email", {
    required: true,
    rule: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email",
    },
  });

  const [getMail, gettingMail, getMailError, getMailSuccess] =
    useForgetPassword();

  const handleRequestError = (errors) => {
    if (!errors) return;

    setEmailError(errors?.email?.[0]);
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    showEmailError();

    if (emailIsValid) {
      const response = await getMail(email);
      if (response) handleRequestError(response);
    }
  };

  const emailRef = useRef();
  useEffect(() => {
    emailRef.current.focus();
  }, []);

  return (
    <AuthSectionContainer title="Reset your password?" className={"forgot"}>
      <p className="info-text">
        To reset your password, please enter the email address of your
        PhysioTrack account.
        <br />
        We will send you an email that will allow you to reset your password.
      </p>
      <ResponseStatus status={"error"}>{getMailError}</ResponseStatus>
      <ResponseStatus status={"success"}>{getMailSuccess}</ResponseStatus>
      {!getMailSuccess && (
        <form onSubmit={submitHandler}>
          <FormControl>
            <p className="error-message">{emailError && emailError}</p>
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              size="normal"
              type="text"
              fullWidth
              autoComplete="off"
              value={email}
              error={emailError ? true : false}
              onChange={(e) => setEmail(e.target.value)}
              inputRef={emailRef}
            />
          </FormControl>
          <ButtonLanding
            type="submit"
            name="Get reset email"
            style={{ marginTop: "0.3rem" }}
            loading={gettingMail}
            disabled={getMailSuccess}
          />
        </form>
      )}
      <div className="forgot-redirect">
        <Link to="/login" className="redirect">
          Back to login
        </Link>
      </div>
    </AuthSectionContainer>
  );
}

export default ForgotPassword;
